import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Stethoscope, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function Specialties() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/specialties").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="specialties-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-purple">Departments</span>
          <h1 className="text-4xl sm:text-5xl font-bold">22+ Specialties & Departments</h1>
          <p className="text-slate-600 mt-3 max-w-2xl">Multi-disciplinary teams collaborating across specialties to deliver coordinated, evidence-based care.</p>
        </div>
      </section>
      <section className="container-x py-10 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {items.map((s) => (
          <div key={s.id} id={s.slug} className="card-clean p-6 group" data-testid={`specialty-${s.slug}`}>
            <div className="h-12 w-12 rounded-xl bg-brand-purple/10 text-brand-purple grid place-items-center mb-3 group-hover:bg-brand-purple group-hover:text-white transition"><Stethoscope className="h-6 w-6" /></div>
            <div className="font-semibold text-lg">{s.name}</div>
            <p className="text-sm text-slate-600 mt-2 line-clamp-3">{s.description}</p>
            <Link to={`/doctors?specialty=${encodeURIComponent(s.name)}`} className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand-purple" data-testid={`spec-link-${s.slug}`}>View doctors <ArrowRight className="h-4 w-4" /></Link>
          </div>
        ))}
      </section>
    </div>
  );
}
